import { useEffect, useState } from "react";

import { MBMessageTypes, useCubeMessenger } from "..";

/**
 * Retrieves the company slug from the parent container when embedded in an iframe
 * and return it when it's received
 */
export const useRetrieveCompanySlug = () => {
  const [companySlug, setCompanySlug] = useState<string | null>(null);
  const { sendMessage } = useCubeMessenger({
    handlers: {
      [MBMessageTypes.sendCompanySlug]: payload => {
        setCompanySlug(payload);
      },
    },
  });

  useEffect(() => {
    sendMessage({ type: MBMessageTypes.requestCompanySlug });
  }, [sendMessage]);

  return companySlug;
};
